import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import ServiceAreaMap from './components/ServiceAreaMap';
import RegionalTeamCard from './components/RegionalTeamCard';
import LocalSuccessStories from './components/LocalSuccessStories';
import EmergencyServiceCard from './components/EmergencyServiceCard';
import LocalPartnerships from './components/LocalPartnerships';
import logo from '../../../public/assets/images/fibrelogo.png';


const ServiceAreasLocalTeams = () => {
  const navigate = useNavigate();
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [userLocation, setUserLocation] = useState(null);

  useEffect(() => {
    // ✅ Detect real user location using browser geolocation + OpenStreetMap API
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            const res = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
            );
            const data = await res.json();
            const detectedLocation = {
              region: data.address.state || data.address.county || 'Unknown Region',
              city: data.address.city || data.address.town || data.address.village || 'Unknown City',
              country: data.address.country || 'Unknown Country'
            };
            setUserLocation(detectedLocation);
          } catch (err) {
            console.error('Error fetching location:', err);
            setUserLocation({ region: 'N/A', city: 'N/A', country: 'N/A' });
          }
        },
        (error) => {
          console.error('Geolocation error:', error);
          setUserLocation({ region: 'N/A', city: 'N/A', country: 'N/A' });
        }
      );
    } else {
      setUserLocation({ region: 'N/A', city: 'N/A', country: 'N/A' });
    }
  }, []);

  const handleRegionSelect = (region) => {
    setSelectedRegion(region);
  };

  const serviceRegions = [
  { id: 1, name: "London", coords: { lat: 51.5074, lng: -0.1278 }, coverage: "100%", teams: 12, projects: 320, responseTime: "2h" },
  { id: 2, name: "Manchester", coords: { lat: 53.4808, lng: -2.2426 }, coverage: "90%", teams: 8, projects: 210, responseTime: "3h" },
  { id: 3, name: "Birmingham", coords: { lat: 52.4862, lng: -1.8904 }, coverage: "85%", teams: 7, projects: 180, responseTime: "2.5h" },
  { id: 4, name: "Liverpool", coords: { lat: 53.4084, lng: -2.9916 }, coverage: "80%", teams: 6, projects: 160, responseTime: "3h" },
  { id: 5, name: "Leeds", coords: { lat: 53.8008, lng: -1.5491 }, coverage: "75%", teams: 6, projects: 140, responseTime: "3h" },
  { id: 6, name: "Newcastle", coords: { lat: 54.9784, lng: -1.6174 }, coverage: "70%", teams: 5, projects: 120, responseTime: "3.5h" },
  { id: 7, name: "Sheffield", coords: { lat: 53.3811, lng: -1.4701 }, coverage: "65%", teams: 5, projects: 110, responseTime: "3h" },
  { id: 8, name: "Nottingham", coords: { lat: 52.9548, lng: -1.1581 }, coverage: "60%", teams: 4, projects: 95, responseTime: "2.5h" },
  { id: 9, name: "Bristol", coords: { lat: 51.4545, lng: -2.5879 }, coverage: "55%", teams: 4, projects: 90, responseTime: "2h" },
  { id: 10, name: "Cardiff", coords: { lat: 51.4816, lng: -3.1791 }, coverage: "50%", teams: 3, projects: 85, responseTime: "2.5h" },
  { id: 11, name: "Belfast", coords: { lat: 54.5973, lng: -5.9301 }, coverage: "45%", teams: 3, projects: 70, responseTime: "4h" },
  { id: 12, name: "Edinburgh", coords: { lat: 55.9533, lng: -3.1883 }, coverage: "70%", teams: 5, projects: 120, responseTime: "3h" },
  { id: 13, name: "Glasgow", coords: { lat: 55.8642, lng: -4.2518 }, coverage: "75%", teams: 6, projects: 130, responseTime: "3h" },
  { id: 14, name: "Aberdeen", coords: { lat: 57.1497, lng: -2.0943 }, coverage: "40%", teams: 3, projects: 60, responseTime: "4h" },
  { id: 15, name: "Dundee", coords: { lat: 56.4620, lng: -2.9707 }, coverage: "35%", teams: 2, projects: 50, responseTime: "4h" },
  { id: 16, name: "Inverness", coords: { lat: 57.4778, lng: -4.2247 }, coverage: "30%", teams: 2, projects: 40, responseTime: "5h" },
  { id: 17, name: "Brighton", coords: { lat: 50.8225, lng: -0.1372 }, coverage: "60%", teams: 3, projects: 70, responseTime: "2h" },
  { id: 18, name: "Southampton", coords: { lat: 50.9097, lng: -1.4044 }, coverage: "55%", teams: 3, projects: 65, responseTime: "2h" },
  { id: 19, name: "Portsmouth", coords: { lat: 50.8198, lng: -1.0880 }, coverage: "50%", teams: 3, projects: 60, responseTime: "2h" },
  { id: 20, name: "Cambridge", coords: { lat: 52.2053, lng: 0.1218 }, coverage: "45%", teams: 2, projects: 55, responseTime: "2.5h" },
  { id: 21, name: "Oxford", coords: { lat: 51.7520, lng: -1.2577 }, coverage: "50%", teams: 2, projects: 60, responseTime: "2.5h" },
  { id: 22, name: "Leicester", coords: { lat: 52.6369, lng: -1.1398 }, coverage: "55%", teams: 3, projects: 65, responseTime: "2.5h" },
  { id: 23, name: "Coventry", coords: { lat: 52.4068, lng: -1.5197 }, coverage: "50%", teams: 2, projects: 55, responseTime: "2.5h" },
  { id: 24, name: "Hull", coords: { lat: 53.7676, lng: -0.3274 }, coverage: "40%", teams: 2, projects: 50, responseTime: "3h" },
  { id: 25, name: "Stoke-on-Trent", coords: { lat: 53.0027, lng: -2.1794 }, coverage: "45%", teams: 2, projects: 55, responseTime: "3h" },
  { id: 26, name: "York", coords: { lat: 53.9590, lng: -1.0815 }, coverage: "40%", teams: 2, projects: 50, responseTime: "3h" },
  { id: 27, name: "Milton Keynes", coords: { lat: 52.0406, lng: -0.7594 }, coverage: "50%", teams: 2, projects: 55, responseTime: "2.5h" },
  { id: 28, name: "Reading", coords: { lat: 51.4543, lng: -0.9781 }, coverage: "55%", teams: 3, projects: 65, responseTime: "2h" },
  { id: 29, name: "Exeter", coords: { lat: 50.7184, lng: -3.5339 }, coverage: "40%", teams: 2, projects: 45, responseTime: "3h" },
  { id: 30, name: "Plymouth", coords: { lat: 50.3755, lng: -4.1427 }, coverage: "35%", teams: 2, projects: 40, responseTime: "3h" }
];



  const coverageStats = [
    {
      icon: "MapPin",
      label: "Service Areas",
      value: "15+ Regions",
      description: "Comprehensive coverage across UK metropolitan areas"
    },
    {
      icon: "Users",
      label: "Local Teams",
      value: "10+ Teams",
      description: "Dedicated regional specialists across the UK"
    },
    {
      icon: "Clock",
      label: "Response Time",
      value: "< 2 Hours",
      description: "Average emergency response time in London"
    },
    {
      icon: "Award",
      label: "Success Rate",
      value: "99.5%",
      description: "High client satisfaction and successful project delivery"
    }
  ];

  const complianceInfo = [
    {
      region: "All UK Regions",
      requirements: [
        "OFCOM telecommunications regulations compliance",
        "Local council permits and planning approval",
        "BSI fibre optic installation standards",
        "Health & Safety Executive (HSE) compliance"
      ]
    },
    {
      region: "London",
      requirements: [
        "Transport for London (TfL) wayleave agreements",
        "London borough council right-of-way permits",
        "Historic England building compliance (where applicable)",
        "Crossrail and major infrastructure coordination"
      ]
    },
    {
      region: "Scotland",
      requirements: [
        "Scottish Government telecom regulations",
        "SEPA environmental compliance",
        "Scottish Power utility coordination",
        "Local council permits for urban fibre rollout"
      ]
    }
  ];
  

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Service Areas & Local Teams - Xtreem Fibre Solutions</title>
        <meta
          name="description"
          content="Find your local Xtreem Fibre Solutions team. Comprehensive fiber optic services across 50+ states with regional expertise, emergency support, and local partnerships."
        />
        <meta
          name="keywords"
          content="fiber optic service areas, local teams, regional coverage, emergency support, telecommunications contractors"
        />
      </Helmet>
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary via-secondary to-accent text-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Local Teams, National Excellence
              </h1>
              <p className="text-xl opacity-90 max-w-3xl mx-auto mb-8">
                Expert fiber optic services delivered by regional specialists who understand your local infrastructure, regulations, and business environment.
              </p>

              {userLocation && (
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 max-w-md mx-auto mb-8">
                  <div className="flex items-center justify-center space-x-2 text-sm">
                    <Icon name="MapPin" size={16} />
                    <span>
                      Detected Location: {userLocation.city}, {userLocation.country}
                    </span>
                  </div>
                  <div className="text-xs opacity-75 mt-1">
                    Serving the {userLocation.region}
                  </div>
                </div>
              )}

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  variant="secondary"
                  size="lg"
                  iconName="Phone"
                  iconPosition="left"
                  className="cta-primary"
                >
                  Find Your Local Team
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  iconName="AlertTriangle"
                  iconPosition="left"
                  className="border-white text-white hover:bg-white hover:text-primary"
                >
                  Emergency: 1-800-FIBER-911
                </Button>
              </div>
            </div>

            {/* Coverage Stats */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {coverageStats?.map((stat, index) => (
                <div
                  key={index}
                  className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center"
                >
                  <Icon name={stat?.icon} size={32} className="mx-auto mb-3" />
                  <div className="text-2xl font-bold mb-1">{stat?.value}</div>
                  <div className="font-semibold mb-2">{stat?.label}</div>
                  <div className="text-sm opacity-75">{stat?.description}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Rest of your component remains unchanged */}
        <section className="py-16 bg-muted">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-text-primary mb-4">
                Interactive Service Area Map
              </h2>
              <p className="text-lg text-text-secondary max-w-2xl mx-auto">
Explore our UK service regions and discover details about coverage, local teams, and recent projects. Click on any region marker to view its service information.
              </p>
            </div>

            <div className="w-full relative z-0">
                <ServiceAreaMap
/>


              </div>
              
          </div>
        </section>
{/* Nationwide Service Regions */}
<section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-12">
      <h2 className="text-3xl font-bold text-text-primary mb-4">
        Nationwide Service Coverage
      </h2>
      <p className="text-lg text-text-secondary max-w-2xl mx-auto">
        We deliver fibre optic solutions across all major regions of the UK & Scotland.  
        Below is a list of our active service locations.
      </p>
    </div>

    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {serviceRegions.map((region) => (
  <div
    key={region.id}
    className="bg-muted rounded-lg shadow-sm p-4 text-center text-text-primary font-medium hover:shadow-md transition"
  >
    <Icon name="MapPin" size={16} className="inline-block mr-2 text-primary" />
    {region.name}
  </div>
))}

    </div>
  </div>
</section>

        {/* Local Success Stories */}
        {/* <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-text-primary mb-4">
                Local Success Stories
              </h2>
              <p className="text-lg text-text-secondary max-w-2xl mx-auto">
                Real transformations happening in communities across our service areas. See how local businesses have benefited from our regional expertise.
              </p>
            </div>

            <LocalSuccessStories />
          </div>
        </section> */}

        {/* Emergency Services */}
        <section className="py-16 bg-muted">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-text-primary mb-4">
                24/7 Emergency Support
              </h2>
              <p className="text-lg text-text-secondary max-w-2xl mx-auto">
                When critical network issues arise, our regional emergency response teams are ready to restore your connectivity quickly and efficiently.
              </p>
            </div>

            <EmergencyServiceCard />
          </div>
        </section>

        {/* Local Partnerships */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-text-primary mb-4">
                Local Partnerships & Certifications
              </h2>
              <p className="text-lg text-text-secondary max-w-2xl mx-auto">
                Strong relationships with regional utilities, technology providers, and business organizations ensure seamless project execution and ongoing support.
              </p>
            </div>

            <LocalPartnerships />
          </div>
        </section>

        {/* Compliance Info */}
        <section className="py-16 bg-muted">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-text-primary mb-4">
                Regional Compliance & Regulations
              </h2>
              <p className="text-lg text-text-secondary max-w-2xl mx-auto">
                Our local teams understand and comply with all regional regulations, permit requirements, and utility coordination processes.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {complianceInfo?.map((info, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-brand-moderate p-6"
                >
                  <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
                    <Icon
                      name="Shield"
                      size={20}
                      className="mr-2 text-primary"
                    />
                    {info?.region}
                  </h3>
                  <ul className="space-y-3">
                    {info?.requirements?.map((requirement, reqIndex) => (
                      <li
                        key={reqIndex}
                        className="flex items-start space-x-2 text-sm"
                      >
                        <Icon
                          name="CheckCircle"
                          size={14}
                          className="text-success mt-0.5 flex-shrink-0"
                        />
                        <span className="text-text-secondary">
                          {requirement}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-gradient-to-r from-primary to-secondary text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold mb-4">
              Ready to Connect with Your Local Team?
            </h2>
            <p className="text-xl opacity-90 mb-8">
              Get personalized service from fiber optic experts who understand your regional infrastructure and business needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="secondary"
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                className="cta-primary"
                onClick={() => {navigate('/get-quote-consultation')}}
              >
                Schedule Local Consultation
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="MessageSquare"
                iconPosition="left"
                className="border-white text-white hover:bg-white hover:text-primary"
                onClick={() => {navigate('/get-quote-consultation')}}
              >
                Get Regional Quote
              </Button>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="relative">
                  <img
                                                  src={logo}
                                                      alt="Xtreem Fibre Solutions"
                                                      width={80}
                                                      height={80}
                                                      className="h-16 w-auto brightness-0 invert transition-transform duration-300 group-hover:scale-105"/>
                </div>
                <div>
                  <h3 className="text-lg font-bold">Xtreem Fibre Solutions</h3>
                  <p className="text-sm opacity-75">
                    Infrastructure Transformation
                  </p>
                </div>
              </div>
              <p className="text-sm opacity-75 mb-4">
                Connecting businesses to their digital future through expert
                fiber optic solutions.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Emergency Support</h4>
              <div className="space-y-2 text-sm">
                <div className="flex items-center space-x-2">
                  <Icon name="Phone" size={14} />
                  <span>1-800-FIBER-911</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Clock" size={14} />
                  <span>24/7/365 Available</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Regional Offices</h4>
              <div className="space-y-2 text-sm opacity-75">
                <div>London HQ: 01483 343 064</div>
                {/* <div>Manchester: +44 161 850 0022</div>
                <div>Birmingham: +44 121 450 0033</div>
                <div>Glasgow: +44 141 330 0044</div>
                <div>Brighton: +44 1273 550 0055</div> */}
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Certifications</h4>
              <div className="space-y-2 text-sm opacity-75">
                <div>BICSI Certified</div>
                <div>NECA Contractor</div>
                <div>FOA Approved</div>
                <div>OSHA Compliant</div>
              </div>
            </div>
          </div>

          <div className="border-t border-slate-700 mt-8 pt-8 text-center text-sm opacity-75">
            <p>
              &copy; {new Date()?.getFullYear()} Xtreem Fibre Solutions. All
              rights reserved. | Licensed & Insured in All Service Areas
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ServiceAreasLocalTeams;
